import * as React from "react";
import { markdown, ReactSpecimen } from "catalog";
import { Tag, RemovableTag } from "./Tag";
import { primaryColors } from "../theme/colors";
export default () => markdown `

## Tags

${(<ReactSpecimen span={2}>
    <Tag label="I am a tag"/>
  </ReactSpecimen>)}

${(<ReactSpecimen span={2}>
    <Tag appearance="light" label="I am a tag"/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark span={2}>
    <Tag appearance="inverted" label="I am a tag"/>
  </ReactSpecimen>)}

### Tags with type

Tags with a defined \`tagType\` will display an icon.

${(<ReactSpecimen span={2}>
    <Tag tagType="Dimension" label="Dimension"/>
    <Tag tagType="Topic" label="Topic"/>
    <Tag tagType="Location" label="Location"/>
    <Tag tagType="Time" label="Time"/>
  </ReactSpecimen>)}

${(<ReactSpecimen span={2}>
    <Tag appearance="light" tagType="Dimension" label="Dimension"/>
    <Tag appearance="light" tagType="Topic" label="Topic"/>
    <Tag appearance="light" tagType="Location" label="Location"/>
    <Tag appearance="light" tagType="Time" label="Time"/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark span={2}>
    <Tag appearance="inverted" tagType="Dimension" label="Dimension"/>
    <Tag appearance="inverted" tagType="Topic" label="Topic"/>
    <Tag appearance="inverted" tagType="Location" label="Location"/>
    <Tag appearance="inverted" tagType="Time" label="Time"/>
  </ReactSpecimen>)}

### Removable tags

${(<ReactSpecimen span={2}>
    <RemovableTag tagType="Dimension" label="I am a tag"/>
  </ReactSpecimen>)}

${(<ReactSpecimen span={2}>
    <RemovableTag appearance="light" tagType="Topic" label="I am a tag"/>
  </ReactSpecimen>)}

${(<ReactSpecimen dark span={2}>
    <RemovableTag appearance="inverted" tagType="Time" label="I am a tag"/>
  </ReactSpecimen>)}
### Tags with action

Tags are \`<button>\`s, so they allow all button props.

~~~hint
Do we need tags as links? Should all tags be actually links?
~~~

${(<ReactSpecimen>
    <Tag label="Click me" onClick={() => alert("hello")}/>
  </ReactSpecimen>)}


${(<ReactSpecimen>
    <RemovableTag label="Click me" onClick={() => alert("hello")}/>
  </ReactSpecimen>)}

### A bunch of tags

Tags have a maximum width, and long labels get cut off (they're still visible as the element's \`title\`).

Tags are rendered **inline**, so don't forget to add margins or spaces.

${(<ReactSpecimen>
    <div style={{
    maxWidth: 420,
    lineHeight: "32px",
    color: primaryColors.zuerichBlue,
    fontFamily: "sans-serif"
}}>
      <Tag label="I am a tag"/> <Tag label="I am another tag"/>{" "}
      <Tag label="I am a reeeeeeeeeallallallly looooooooooong tag"/>{" "}
      <RemovableTag tagType="Time" label="I am a reeeeeeeeeallallallly looooooooooong tag"/>{" "}
      <Tag label="I am a tag"/> <Tag label="I am another tag"/>{" "}
      <Tag label="I am a tag"/> <Tag label="I am another tag"/> Some text!
    </div>
  </ReactSpecimen>)}



`;



// WEBPACK FOOTER //
// ./src/components/Tag.docs.tsx